export enum CharacteristicTypeEnum {
  RECIPIENTS = "recipients",
  SUPPORTED_SCENARIOS = "scenarios",
  UNSUPPORTED_SCENARIOS = "unsupportedScenarios",
  PLATFORM_TYPE = "platformType",
  AUTHORIZATION_TYPE = "authorizationType",
  TOKEN_URI = "tokenUri",
  ISSUER_URI = "issuerUri",
  PLATFORM_URI = "platformUri",
  PLATFORM_UI_URL = "platformUiUrl",
  SERVICE_ACCOUNT_CLIENT_ID = "serviceAccountClientId",
  CLIENT_ID = "clientId",
  VALID_FROM = "validFrom",
  VALID_TO = "validTo",
  FLAG = "flag",
  SUB_ENTITIES = "subEntities",
  PROXY_SCENARIO_WORKFLOWS = "proxyScenarioWorkflows",
  PROXY_SCENARIO_WORKFLOW_OVERRIDES = "proxyScenarioWorkflowOverrides"
}
